import "../pages.scss"
import { DescuentosState } from '../../context/descuentos/DescuentosState';
import Datatable from "./descuentosTable/Datatable"

const DescuentosPage = () => {
  return (
    <>
      <DescuentosState>
        <Datatable />
      </DescuentosState>
    </>
  )
}

export default DescuentosPage